export default function Loading() {
  return (
    <div className="flex items-center justify-center py-20">
      <div className="w-8 h-8 border-2 border-brand-100 border-t-brand-500 rounded-full animate-spin" />
    </div>
  );
}
